import {Box, Typography} from '@mui/material';
import {MailLockTwoTone, MailTwoTone, MarkEmailUnreadTwoTone} from '@mui/icons-material';

import {Colors} from '../common/colors';
import {Theme} from '../../types';
import {useTranslation} from 'react-i18next';

export function EmailWasSentMessage(props: {theme?: Theme}) {
    const bgColor = props.theme?.background_color ?? Colors.first;
    const {t} = useTranslation('common');
    return (
        <Box
            sx={{
                display: 'flex',
                maxWidth: 400,
                flexDirection: 'column',
                alignSelf: 'center',
                justifySelf: 'center',
                alignItems: 'center',
                gap: 2,
            }}
        >
            <MarkEmailUnreadTwoTone sx={{width: 40, height: 40, color: bgColor}} />
            <Typography alignSelf="center" textAlign="center">
                {t('info.support_email_sent')}
            </Typography>
        </Box>
    );
}
